const outletNames = {
  // 진보적 매체
  hani: "한겨레",
  ohmynews: "오마이뉴스",
  pressian: "프레시안",
  khan : "경향신문",
  ddanzi: "딴지일보",
  sisain: "시사in",
  mediatoday: "미디어오늘",
  nocutnews: "노컷뉴스",
  mt: "머니투데이",
  edaily: "이데일리",
  redian: "레디앙",
  medias: "미디어스",
  vop: "민중의 소리",

  // 중도적 매체
  seoul: "서울신문",
  hankookilbo: "한국일보",
  naeil: "내일신문",
  newsis: "뉴시스",

  // 보수적 매체
  chosun: "조선일보",
  joongang: "중앙일보",
  donga: "동아일보",
  munhwa: "문화일보",
  kukmin: "국민일보",
  newdaily: "뉴데일리",
  indynews: "독립신문",
  dailian: "데일리안",
  hankuknon: "한국논단",
  newslive: "뉴스라이브",
  asiatoday: "아시아투데이",
  cnbnews: "CNB뉴스",
  breaknews: "브레이크뉴스",
  dailynk: "데일리NK",
  kukinews: "쿠키뉴스",
  yna: "연합뉴스",
  ytn: "YTN",


  //성향 정보 아직 모름
  biz : "sbs비즈",
  yonhapnewstv : "연합뉴스TV",
  seoulwire : "서울와이어",
  kmib : "국민일보",
  ekn : "에너지경제",
  news1 : "뉴스1",
  gpkorea : "지피코리아",
  mbn : "MBN",
  gnmaeil : "경남매일",
  enewstoday : "이뉴스투데이",
  newsroad : "뉴스로드",
  mk : "매일경제",
  kgnews : "경기신문",
};

export default outletNames;
